import React from 'react'
import { IconButton, MenuItem, PopupMenu, Typography, makeStyles } from '@paintscout/ui'
import type { MuiTheme as Theme } from '@paintscout/ui'
import AddIcon from '@material-ui/icons/Add'
import { socialLinkTypes } from './socialLinkTypes'

interface AddSocialLinkRowProps {
  onAdd: (label: string) => void
}

// Same root/label classes as SocialLinkRow/StringOption so this row measures the same
// height as every other options row; `button` matches ButtonSelectOption's square button
// styling (borderRadius: 0 turns MUI's default circular hover overlay into a square one).
const useStyles = makeStyles(
  (theme: Theme) => {
    return {
      root: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      },
      label: {
        fontSize: '.9rem',
        color: theme.palette.grey[800]
      },
      button: {
        borderRadius: 0,
        height: 26,
        width: 26,
        color: theme.palette.grey[800],
        '& svg': {
          fontSize: '1rem',
          color: theme.palette.grey[800]
        },
        '&:hover': {
          color: theme.palette.grey[800]
        }
      }
    }
  },
  { name: 'AddSocialLinkRow' }
)

export default function AddSocialLinkRow(props: AddSocialLinkRowProps) {
  const classes = useStyles(props)
  const { onAdd } = props

  return (
    <div className={classes.root}>
      <Typography className={classes.label} variant={'h5'}>
        Add Link
      </Typography>
      <PopupMenu
        component={
          <IconButton classes={{ root: classes.button }}>
            <AddIcon />
          </IconButton>
        }
      >
        {socialLinkTypes.map((type) => (
          <MenuItem key={type.label} icon={type.Icon} onClick={() => onAdd(type.label)}>
            {type.label}
          </MenuItem>
        ))}
      </PopupMenu>
    </div>
  )
}
